<footer>
  <div class="content-wrapper">
    <div class="footer-grid">
      <div class="footer-column">
        <div class="footer-kicker">PRO MEBLE</div>
        <div class="slogan-1">Meble na wymiar</div>
        <div class="slogan-2">Projekt • produkcja • montaż</div>
      </div>
      <div class="footer-column">
        <div class="footer-kicker">Skróty</div>
        <div class="footer-links">
          <a [routerLink]="'/realizacje'" class="footer-link-portfolio">Realizacje</a>
          <a [routerLink]="'/proces'" class="footer-link-process">Proces</a>
          <a [routerLink]="'/faq'" class="footer-link-faq">FAQ</a>
          <a [routerLink]="'/kontakt'" class="footer-link-contact">Kontakt</a>
        </div>
      </div>
      <div class="footer-column">
        <div class="footer-kicker">Prywatność</div>
        <div class="footer-links">
          <a [routerLink]="'/informacje-prawne'" class="footer-link-legal-info">Informacje prawne</a>
          <a [routerLink]="'/polityka-prywatnosci'" class="footer-link-privacy-policy">Polityka prywatności</a>
          <a href="" (click)="openCookieSettings($event)">Cookies</a>
        </div>
      </div>
    </div>

    <div class="sub-footer">
      <span class="hint">&copy;{{ year }}</span>
      <img [ngSrc]="'/assets/images/pro-meble-logo.png'" [width]="80" [height]="20" alt="PRO MEBLE Logo" />
    </div>
  </div>
</footer>
